"use client";

import * as React from "react";
import { Heart, MessageCircle, Play, Share2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Link } from "@/components/common/Link";
const reels = [{
  id: 1,
  title: "Matterhorn All Ivy Showcase",
  likes: "12.4K",
  comments: "342",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575318/img/reel_luxury_campaign_bts.png",
  titleClassName: "absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/90 !bg-[url(https://rich-pup.10web.cloud/wp-content/uploads/2026/03/4.png)] absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/90 !bg-[url(https://rich-pup.10web.cloud/wp-content/uploads/2026/03/Screenshot-2026-03-09-at-10.37.32-PM.png)] absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/90 !bg-[url(https://moondosmedia.com/wp-content/uploads/2026/03/Screenshot-2026-03-09-at-10.38.09-PM.png)] absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/90 !bg-[url(https://moondosmedia.com/wp-content/uploads/2026/03/Screenshot-2026-03-09-at-10.38.09-PM.png)]"
}, {
  id: 2,
  title: "How to Become: a Fashion Designer",
  likes: "8.9K",
  comments: "156",
  image: "https://moondosmedia.com/wp-content/uploads/2026/03/Screenshot-2026-03-11-at-7.38.04-PM.png?v=drqcefi39zs"
}, {
  id: 3,
  title: "Personal Brand Content",
  likes: "45.2K",
  comments: "1.2K",
  image: "https://rich-pup.10web.cloud/wp-content/uploads/2026/03/Screenshot-2026-03-09-at-10.40.19-PM.png?v=nh037c5cnmp"
}, {
  id: 4,
  title: "Nissan Skyline GT-R \"Hakosuka\" (KPGC10)",
  likes: "23.1K",
  comments: "890",
  image: "https://rich-pup.10web.cloud/wp-content/uploads/2026/03/Screenshot-2026-03-09-at-10.36.49-PM.png?v=iw33fupuev"
}, {
  id: 5,
  title: "Poetry In Motion",
  likes: "5.6K",
  comments: "89",
  image: "https://rich-pup.10web.cloud/wp-content/uploads/2026/03/Screenshot-2026-03-09-at-10.33.48-PM.png?v=kj844w1w7xj"
}, {
  id: 6,
  title: "Luxury Car Campaign - Behind the Scenes",
  likes: "15.8K",
  comments: "421",
  image: "https://moondosmedia.com/wp-content/uploads/2026/03/Screenshot-2026-03-09-at-10.39.13-PM.png?v=e0fuflnbsm5"
}];
export default function TheSocialReel() {
  return <section id="the-social-reel" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-900/20 via-background to-background pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-purple-900/10 via-transparent to-transparent pointer-events-none" />

      {}
      <div className="absolute top-16 right-8 md:top-24 md:right-24 z-20 rotate-[12deg] animate-in fade-in slide-in-from-top-10 duration-1000">
        
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-12 md:mb-20 max-w-3xl">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter mb-6 text-balance">
            The Social Reel
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl text-balance">
            Short-form content engineered for maximum engagement. We craft visual narratives that stop the scroll and build your audience.
          </p>
        </div>

        <div className="relative">
          <Carousel opts={{
          align: "start",
          dragFree: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {reels.map((reel, i) => <CarouselItem key={reel.id} data-index={i} className="pl-4 md:pl-6 basis-[75%] sm:basis-[45%] md:basis-[35%] lg:basis-[25%] xl:basis-[20%]">
                  <div className="relative group rounded-3xl overflow-hidden border border-white/10 bg-black shadow-2xl transition-all duration-500 hover:-translate-y-2 hover:shadow-indigo-500/20">
                    <AspectRatio ratio={9 / 16}>
                      {}
                      {i === 0 ? <Link to="https://www.instagram.com/p/C-LXL5zSxND/" newTab className="block w-full h-full">
                          <img src={reel.image} alt={reel.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 opacity-90 group-hover:opacity-100" />
                        </Link> : <img src={reel.image} alt={reel.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 opacity-90 group-hover:opacity-100" />}
                      
                      {}
                      <div className={`${reel.titleClassName || ""} absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/90`} />
                      
                      {}
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
                        <div className="bg-white/20 backdrop-blur-md rounded-full p-5 border border-white/30 shadow-xl transform scale-90 group-hover:scale-100 transition-transform duration-300">
                          <Play className="w-8 h-8 text-white fill-white ml-1" />
                        </div>
                      </div>

                      {}
                      <div className="absolute top-0 left-0 right-0 p-4 flex justify-between items-center z-10">
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-500 p-[2px]">
                            <div className="w-full h-full rounded-full bg-black border border-black overflow-hidden">
                               <img src="https://rich-pup.10web.cloud/wp-content/uploads/2026/03/cropped-cropped-4-1.png?v=5awxfaobqd4" alt="Moondos Media" className="w-full h-full object-cover" />
                            </div>
                          </div>
                          <span className="text-white text-xs font-semibold drop-shadow-md">moondosmedia</span>
                        </div>
                      </div>

                      {}
                      <div className="absolute bottom-0 left-0 right-0 p-5 z-10">
                        <p className="text-white font-medium text-sm mb-4 line-clamp-2 drop-shadow-md">
                          {reel.title}
                        </p>
                        <div className="flex items-center justify-between text-white/90">
                          <div className="flex items-center gap-4">
                            <div className="flex flex-col items-center gap-1 group/icon cursor-pointer">
                              <Heart className="w-6 h-6 transition-transform group-hover/icon:scale-110 group-hover/icon:fill-red-500 group-hover/icon:text-red-500" />
                              <span className="text-[10px] font-medium">{reel.likes}</span>
                            </div>
                            <div className="flex flex-col items-center gap-1 group/icon cursor-pointer">
                              <MessageCircle className="w-6 h-6 transition-transform group-hover/icon:scale-110" />
                              <span className="text-[10px] font-medium">{reel.comments}</span>
                            </div>
                            <div className="flex flex-col items-center gap-1 group/icon cursor-pointer">
                              <Share2 className="w-6 h-6 transition-transform group-hover/icon:scale-110" />
                              <span className="text-[10px] font-medium">Share</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AspectRatio>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="hidden md:block">
              <CarouselPrevious className="left-4 bg-background/50 backdrop-blur-md border-white/20 text-white hover:bg-background/80 hover:text-white" />
              <CarouselNext className="right-4 bg-background/50 backdrop-blur-md border-white/20 text-white hover:bg-background/80 hover:text-white" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}